import { useTableActionContext } from '@aibees/elephant/context';
import { TableProps } from '@aibees/shared/components';
import { EXPORT_SIZE_LIMIT } from '@aibees/shared/features/advance-table/components/advanced-table-select-popup/constant';
import { useGetBrowseIdsApiData } from '@aibees/shared/features/advance-table/components/table';
import { useEffect, useMemo } from 'react';

export function useUpdateActionSelectedIds(
  table?: TableProps,
  singleItemId?: string
) {
  const tableSelection = table?.selection;
  const getIdsApi = useGetBrowseIdsApiData(table);
  const { setIds } = useTableActionContext();

  const ids = useMemo(() => {
    if (singleItemId) return [singleItemId];
    const idsDraft = [
      ...(tableSelection?.added ?? []),
      ...(getIdsApi?.data ?? []),
      ...(tableSelection?.included ?? []),
      ...(tableSelection?.topSelected ?? []),
    ]
      .slice(0, EXPORT_SIZE_LIMIT)
      .filter((i) => !tableSelection?.excluded.includes(i))
      .slice(0, tableSelection?.count);
    return idsDraft;
  }, [
    getIdsApi?.data,
    singleItemId,
    tableSelection?.added,
    tableSelection?.count,
    tableSelection?.excluded,
    tableSelection?.included,
    tableSelection?.topSelected,
  ]);

  useEffect(() => {
    setIds(ids);
  }, [table?.selection, ids]);
}
